//para el formulario del super usuario
export const SAVE_SUPER_USER = "SAVE_SUPER_USER";

//Cambios de Lu
export const courses = {
  LIST_PAGES_STUDENTS: "LIST_PAGES_STUDENTS",
  LIST_COURSES_SELECTION: "LIST_COURSES_SELECTION",
  LIST_COURSES_CERTIFICATION: "LIST_COURSES_CERTIFICATION",
  SELECT_COURSE: "SELECT_COURSE",
};
//

export const userTypes = {
  USER_LOGIN: "USER_LOGIN",
  LOGOUT_USER: "LOGOUT_USER",
  USER_REGISTER: "USER_REGISTER",
  USER_UPDATEPROFILE: "USER_UPDATEPROFILE",
};

export const studentsType = {
  GET_INFOSTUDENT: "GET_INFOSTUDENT",
  GET_STUDENTS: "GET_STUDENTS",
};

export const typeCourseTypes = {
  ADD_TYPECOURSE: "ADD_TYPECOURSE",
};

export const typeBenefitTypes = {
  ADD_BENEFITTYPE: "ADD_BENEFITTYPE",
  GET_BENEFIT: "GET_BENEFIT",
};

export const typeCohort = {
  ADD_COHORT: "ADD_COHORT",
  GET_COHORT: "GET_COHORT",
};

export const typeFormAdminAndStydents = {
  ADD_FORMADMINSTUDENTS: "ADD_FORMADMINSTUDENTS",
  GET_FORMADMINSTUDENTS: "GET_FORMADMINSTUDENTS",
  UPDATE_FORMADMINSTUDENTS: "UPDATE_FORMADMINSTUDENTS",
  GET_STUDENTS_BY_PROGRAM: "GET_STUDENTS_BY_PROGRAM",
};

export const typeStudents = {
  GET_DATA_STUDENTS: "GET_DATA_STUDENTS",
  GET_ESTUDIANTES_SUCCESS: "GET_ESTUDIANTES_SUCCESS",
};

export const typeBenefitSolicitTypes = {
  GET_BENEFIT_SOLICIT_TYPES: "GET_BENEFIT_SOLICIT_TYPES",
};
